/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppModelsCaptureScaleChannelReading } from './AppModelsCaptureScaleChannelReading';
import {
    AppModelsCaptureScaleChannelReadingFromJSON,
    AppModelsCaptureScaleChannelReadingFromJSONTyped,
    AppModelsCaptureScaleChannelReadingToJSON,
    AppModelsCaptureScaleChannelReadingToJSONTyped,
} from './AppModelsCaptureScaleChannelReading';

/**
 * 
 * @export
 * @interface ScaleReading
 */
export interface ScaleReading {
    [key: string]: any | any;
    /**
     * 
     */
    channelReadings: { [key: string]: AppModelsCaptureScaleChannelReading; };
    /**
     * 
     */
    weightGrams: number;
    /**
     * 
     */
    rawWeightGrams?: number | null;
    /**
     * 
     */
    calibrationTare?: number | null;
    /**
     * 
     */
    timestamp: number;
    /**
     * 
     */
    smoothedWeightGrams?: number | null;
    /**
     * 
     */
    outlier?: boolean | null;
    /**
     * 
     */
    usedForReportedWeight?: boolean | null;
}

/**
 * Check if a given object implements the ScaleReading interface.
 */
export function instanceOfScaleReading(value: object): value is ScaleReading {
    if ((!('channelReadings' in (value as Record<string, any>)) && !('channel_readings' in (value as Record<string, any>))) || ((value as Record<string, any>)['channelReadings'] === undefined && (value as Record<string, any>)['channel_readings'] === undefined)) return false;
    if ((!('weightGrams' in (value as Record<string, any>)) && !('weight_grams' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightGrams'] === undefined && (value as Record<string, any>)['weight_grams'] === undefined)) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function ScaleReadingFromJSON(json: any): ScaleReading {
    return ScaleReadingFromJSONTyped(json, false);
}

export function ScaleReadingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScaleReading {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'channelReadings': (mapValues(json['channel_readings'], AppModelsCaptureScaleChannelReadingFromJSON)),
        'weightGrams': json['weight_grams'],
        'rawWeightGrams': json['raw_weight_grams'] === undefined ? undefined : json['raw_weight_grams'] === null ? null : json['raw_weight_grams'],
        'calibrationTare': json['calibration_tare'] === undefined ? undefined : json['calibration_tare'] === null ? null : json['calibration_tare'],
        'timestamp': json['timestamp'],
        'smoothedWeightGrams': json['smoothed_weight_grams'] === undefined ? undefined : json['smoothed_weight_grams'] === null ? null : json['smoothed_weight_grams'],
        'outlier': json['outlier'] === undefined ? undefined : json['outlier'] === null ? null : json['outlier'],
        'usedForReportedWeight': json['used_for_reported_weight'] === undefined ? undefined : json['used_for_reported_weight'] === null ? null : json['used_for_reported_weight'],
    };
}

export function ScaleReadingToJSON(json: any): ScaleReading {
    return ScaleReadingToJSONTyped(json, false);
}

export function ScaleReadingToJSONTyped(value?: ScaleReading | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'channel_readings': (mapValues(value['channelReadings'], AppModelsCaptureScaleChannelReadingToJSON)),
        'weight_grams': value['weightGrams'],
        'raw_weight_grams': value['rawWeightGrams'],
        'calibration_tare': value['calibrationTare'],
        'timestamp': value['timestamp'],
        'smoothed_weight_grams': value['smoothedWeightGrams'],
        'outlier': value['outlier'],
        'used_for_reported_weight': value['usedForReportedWeight'],
    };
}

